import { useEffect, useRef } from 'react';

const TrustpilotRating = () => {
  const ref = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src =
      '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;

    document.head.appendChild(script);

    if (window && (window as any).Trustpilot)
      (window as any).Trustpilot.loadFromElement(ref.current, true);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget flex items-center justify-center"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="5da6e25d045cf9000135f914"
      data-style-height="120px"
      data-style-width="235px"
      data-theme="light"
    >
      <a
        href="https://www.trustpilot.com/review/reebelo.com"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotRating;
